function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M10 11V8H8v3H5v2h3v3h2v-3h3v-2h-3z",
  fill: "#4038FF"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3 4a2 2 0 00-2 2v12a2 2 0 002 2h12a2 2 0 002-2v-2.132l4.445 2.964L23 18V6l-1.555-.832L17 8.13V6a2 2 0 00-2-2H3zm0 2h12v5.868l6-4v8.263l-6-4V18H3V6z",
  fill: "#4038FF"
});

var SvgPublishVideos = function SvgPublishVideos(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _ref, _ref2);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEwIDExVjhIOEw4IDExSDVWMTNIOFYxNkgxMFYxM0gxM1YxMUgxMFoiIGZpbGw9IiM0MDM4RkYiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0zIDRDMS44OTU0MyA0IDEgNC44OTU0MyAxIDZWMThDMSAxOS4xMDQ2IDEuODk1NDMgMjAgMyAyMEgxNUMxNi4xMDQ2IDIwIDE3IDE5LjEwNDYgMTcgMThWMTUuODY4NUwyMS40NDUzIDE4LjgzMjFMMjMgMThWNkwyMS40NDUzIDUuMTY3OTVMMTcgOC4xMzE0OFY2QzE3IDQuODk1NDMgMTYuMTA0NiA0IDE1IDRIM1pNMyA2TDE1IDZWMTEuODY4NUwyMSA3Ljg2ODUyVjE2LjEzMTVMMTUgMTIuMTMxNVYxOEgzVjZaIiBmaWxsPSIjNDAzOEZGIi8+Cjwvc3ZnPgo=";
export { SvgPublishVideos as ReactComponent };